import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';


const UserTable = ({
  users,
  selectedUsers,
  onSelectUser,
  onSelectAll,
  onViewUser,
  onDeleteUser
}) => {
  const getStatusBadge = (status) => {
    switch (status) {
      case 'Active':
        return 'bg-success/10 text-success';
      case 'Pending':
        return 'bg-warning/10 text-warning';
      case 'Suspended':
        return 'bg-error/10 text-error';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden shadow-sm">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="px-6 py-4 text-left">
                <Checkbox
                  checked={selectedUsers?.length === users?.length && users?.length > 0}
                  onChange={onSelectAll}
                  indeterminate={
                    selectedUsers?.length > 0 && selectedUsers?.length < users?.length
                  }
                />
              </th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-foreground">
                Name
              </th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-foreground">
                Email
              </th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-foreground">
                Role
              </th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-foreground">
                Practice
              </th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-foreground">
                Status
              </th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-foreground">
                Registration
              </th>
              <th className="px-6 py-4 text-right text-sm font-semibold text-foreground">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {users?.map((user) => (
              <tr key={user?.id} className="hover:bg-muted/30 transition-colors">
                <td className="px-6 py-4">
                  <Checkbox
                    checked={selectedUsers?.includes(user?.id)}
                    onChange={() => onSelectUser(user?.id)}
                  />
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                      <span className="text-sm font-semibold text-primary">
                        {user?.name?.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground">{user?.name}</p>
                      <p className="text-xs text-muted-foreground">{user?.location}</p>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 text-sm text-foreground">{user?.email}</td>
                <td className="px-6 py-4 text-sm text-foreground">{user?.role}</td>
                <td className="px-6 py-4 text-sm text-foreground">{user?.practice}</td>
                <td className="px-6 py-4">
                  <span
                    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusBadge(
                      user?.status
                    )}`}
                  >
                    {user?.status}
                  </span>
                </td>
                <td className="px-6 py-4 text-sm text-muted-foreground">
                  {new Date(user?.registrationDate)?.toLocaleDateString()}
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center justify-end gap-2">
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => onViewUser(user)}
                      iconName="Eye"
                      title="View details"
                    />
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => console.log('Edit user', user?.id)}
                      iconName="Edit"
                      title="Edit user"
                    />
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => onDeleteUser(user?.id)}
                      iconName="Trash2"
                      className="text-error hover:text-error"
                      title="Delete user"
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserTable;